import {AlpineComponent} from 'alpinejs';
import Swiper from 'swiper';
import {PlayerEvents} from '../plugins/video-player/Player';

type PtLatestData = {}

export default (): AlpineComponent<PtLatestData> => ({
  init() {
    const swiperEl = this.$root.querySelector<HTMLElement>('.swiper');
    if (!swiperEl) {
      return;
    }
    new Swiper(swiperEl, {
      slidesPerView: 'auto',
      speed: 500,
      spaceBetween: 24,
      threshold: 10,
      watchOverflow: true,
      followFinger: true,
      mousewheel: {
        forceToAxis: true
      },
      navigation: {
        prevEl: this.$root.querySelector<HTMLElement>('.pt-latest-btn--prev'),
        nextEl: this.$root.querySelector<HTMLElement>('.pt-latest-btn--next')
      },
      on: {
        slideChange: (swiper) => {
          const video: HTMLVideoElement | null = swiper.slides[swiper.previousIndex]
            .querySelector<HTMLVideoElement>('.media-item');
          video?.closest('[x-video-player]')?.dispatchEvent(PlayerEvents.stop);
        }
      }
    });
  }
});
